import { Box } from '@mui/material';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useStepper } from '../partials/actionStepperPartial';
import { OnboardingIntro } from './steps/intro';
import { MapFieldsStep } from '../createImport/steps/mapFields';
import { UploadFileStep } from '../createImport/steps/uploadFile';

export const BACK_TO_OVERVIEW = '/dashboard';

export const OnboardingScreen: FC = () => {
  const {
    activeStep,
    setTitle,
    setSectionTitle,
    setBackToPath,
    setBackToTitle,
    setStepperConfig,
    stepperConfig
  } = useStepper();
  const { t } = useTranslation();

  useEffect(() => {
    setTitle(t('common:WELCOME_MESSAGE'));
    setBackToPath(BACK_TO_OVERVIEW);
    setBackToTitle(t('common:SKIP_SETUP'));
    setStepperConfig([
      { title: t('common:INTRODUCTION') },
      { title: t('common:ADD_EMPLOYEES') },
      { title: t('form:MAP_FIELDS') }
    ]);
  }, []);

  useEffect(() => {
    if (stepperConfig && activeStep && activeStep > stepperConfig.length - 1) {
      setSectionTitle(undefined);
    } else if (activeStep) {
      setSectionTitle(stepperConfig && stepperConfig[activeStep - 1].title);
    }
  }, [activeStep, stepperConfig]);

  return (
    <Box height="calc(100% - 1.5rem)">
      {activeStep === 1 && <OnboardingIntro />}
      {activeStep === 2 && <UploadFileStep />}
      {activeStep === 3 && <MapFieldsStep />}
    </Box>
  );
};
